module.exports = __webpack_public_path__ + "img/loan-status4.07ce3b1d.png";